import { useEffect, useState } from "react";
import { publicApi } from "@/lib/api";
import { Reveal } from "@/components/motion/Reveal";

const INITIAL_CLIENTS = [
  { id: "coredata", nombre: "CoreData", logo_url: "/logos/coredata logo.png" },
  { id: "gaher", nombre: "Gaher", logo_url: "/logos/Logo Gaher.jpg" },
  { id: "coopevictoria", nombre: "Coopevictoria", logo_url: "/logos/coopevictoria.jpg" },
  { id: "cts", nombre: "CTS", logo_url: "/logos/CTS140x60.jpg" },
  { id: "accsa", nombre: "ACCSA", logo_url: "/logos/Logo ACCSA.jpg" },
  { id: "lemen", nombre: "Lemen", logo_url: "/logos/logolemenpocosmargenes.png" },
  { id: "la-cuchara-de-porras", nombre: "La Cuchara de Porras", logo_url: "/logos/lacucharadeporras.png" },
];

export default function Clients() {
  const [items, setItems] = useState(INITIAL_CLIENTS);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    publicApi.clients()
      .then((clients) => {
        if (!clients.length) return;
        const hasCucharaDePorras = clients.some((client) =>
          String(client.nombre || "").toLowerCase().includes("la cuchara de porras"),
        );
        const cucharaDePorras = INITIAL_CLIENTS.find((client) => client.id === "la-cuchara-de-porras");
        setItems(hasCucharaDePorras ? clients : [...clients, cucharaDePorras]);
      })
      .catch(() => {});
  }, []);

  const doubled = [...items, ...items];

  return (
    <section id="clientes" className="relative py-24 md:py-32 border-t border-[#1A1A1A]/10" data-testid="clients-section">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <Reveal>
          <div className="grid grid-cols-12 gap-6 items-end mb-14">
            <div className="col-span-12 md:col-span-8">
              <div className="eyebrow mb-6">— Clientes</div>
              <h2 className="display-2">Organizaciones que <em className="italic text-[#1B3B2B]">han confiado</em> en nosotros.</h2>
            </div>
            <p className="col-span-12 md:col-span-4 text-sm text-[#4A4A4A] leading-relaxed">
              Una muestra de las organizaciones que han confiado en nuestro acompañamiento para fortalecer sus sistemas de gestión.
            </p>
          </div>
        </Reveal>
      </div>

      <div
        className="relative overflow-clip py-8 border-y border-[#1A1A1A]/10"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
        data-testid="clients-marquee"
      >
        <div
          className="clients-track marquee-track"
          style={{ animationPlayState: paused ? "paused" : "running" }}
        >
          {doubled.map((c, i) => (
            <a
              key={`${c.id}-${i}`}
              href={c.website || "#clientes"}
              className="shrink-0 h-20 md:h-24 flex items-center justify-center px-8"
              aria-label={c.nombre}
              data-testid={`client-logo-${i}`}
            >
              <img
                src={c.logo_url}
                alt={`Logo de ${c.nombre}`}
                className="client-logo max-h-full max-w-[160px] md:max-w-[200px] object-contain"
                loading={i < 3 ? "eager" : "lazy"}
                decoding="async"
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
